import InitFormRespondedModal from "./InitFormRespondedModal";
export default InitFormRespondedModal;
